import type { Prototype } from "../prototype-types";

export const terenceDicksonPrototypes: Prototype[] = [
  {
    id: "td-idv-parallel",
    name: "IDV — parallel verification",
    path: "/td/idv-parallel",
    description:
      "Identity verification that runs in parallel with product upload, surfaced through a live package-style ETA tracker. Brand is never blocked — instant-verify and needs-review cohorts.",
    owner: "Terence Dickson",
    createdAt: "2026-06-03",
    lastUpdated: "2026-06-03",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.faire.com/fastly/95117efee9b8aa524e6e1919797f6f14b7c010114aecea5ace4b955920937233.png",
    creationTool: "cursor",
  },
];
